/* Mia More Oils — shared runtime.
   Guarded so repeated <script> tags never double-run. */
if (!window.MMO) {
  window.MMO = (function () {
    'use strict';

    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- <mmo-reveal>: fades its contents in when scrolled into view ---- */
    if (!customElements.get('mmo-reveal')) {
      customElements.define('mmo-reveal', class extends HTMLElement {
        connectedCallback() {
          if (reduced) return;
          this.setAttribute('hidden-until-visible', '');
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            });
          }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
          io.observe(this);
        }
      });
    }

    /* ---- toast ---- */
    var el = null, timer = null;
    function toast(message) {
      if (!el) {
        el = document.createElement('div');
        el.className = 'mmo-toast';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
    }

    /* ---- add to the real Shopify cart ---- */
    function addToCart(variantId, title, button) {
      if (!variantId) return Promise.resolve();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (button) { button.dataset.idle = button.textContent; button.disabled = true; button.textContent = 'Adding…'; }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          toast(title + ' added to your bag.');
          /* Horizon listens on its own cart component; this covers both */
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'mmo' } }));
          document.dispatchEvent(new CustomEvent('mmo:cart:added', { bubbles: true }));
        })
        .catch(function () { toast('Sorry — that item could not be added.'); })
        .finally(function () {
          if (button) { button.disabled = false; button.textContent = button.dataset.idle || 'Add'; }
        });
    }

    /* ---- only run heavy canvas work while on screen ---- */
    function whileVisible(element, start, stop) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0 }).observe(element);
    }

    /* ---- magnetic buttons ---- */
    function magnetise(root) {
      if (reduced || !matchMedia('(hover:hover)').matches) return;
      root.querySelectorAll('[data-magnetic]').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.22 +
            'px,' + (e.clientY - r.top - r.height / 2) * 0.32 + 'px)';
        });
        btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
      });
    }

    return { reduced: reduced, toast: toast, addToCart: addToCart, whileVisible: whileVisible, magnetise: magnetise };
  })();
}
